import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import TabAnalysisChart from 'components/market/tabTradingView';
import TabAnalysisMarket from 'components/market/tabAnalysisMarket';
import TabAnalysisStock from 'components/market/tabAnalysisStock';
import TabAnalysisFilter from 'components/market/tabAnalysisFilter';

import { translate } from 'react-i18next';
import TabAnalysisSignal from 'components/market/tabAnalysisSignal';
import { connect, useDispatch } from 'react-redux';
import { analSecListAllRequest } from './actions';

import * as _ from 'lodash';
import { WebSocketContext } from 'containers/socket/webSocket';

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function CashPage(props) {
  const ws = React.useContext(WebSocketContext);

  const [tabActive, setTabActive] = useState('phan-tich-thi-truong');
  const dispatch = useDispatch();
  const {
    match: { params },
    lang,
    socketReady,
  } = props;
  
  const prevSocketReady = usePrevious(socketReady);

  let query = useQuery();

  React.useEffect(() => {
    return () => {
      var msg = {
        action: 'leave',
        data: 'AlgoData',
      };
      ws.sendMessage(msg);
    };
  }, []);

  useEffect(() => {
    if (socketReady && !_.isEqual(socketReady, prevSocketReady)) {
      var msg = {
        action: 'join',
        data: 'AlgoData',
      };
      setTimeout(() => {
        ws.sendMessage(msg);
      }, 500);
    }
  }, [socketReady]);

  useEffect(() => {
    if (params?.typeId) setTabActive(params?.typeId);
  }, [params?.typeId]);

  useEffect(() => {
    if (lang) {
      dispatch(analSecListAllRequest({ lang: lang }));
    }
  }, [lang]);

  const _searchTxt = query.get('sym') || 'VNINDEX';

  return (
    <div className="page-account d-flex w-100">
      <div className="app-main__inner w-100 p-0">
        <div className="d-flex flex-column w-100">
          {/* <div className="d-flex py-0 pr-2 tabs-cash pl-4">
              {navAnalysis &&
                navAnalysis.map((item, index) => (
                  <Link
                    to={item.path}
                    className={
                      'fz-14 content-read mr-4  ' +
                      (pathname === item.path ? 'active' : '')
                    }
                    key={index}
                  >
                    {t(
                      item.labelCode === 'txt-canh-bao'
                        ? 'txt-canh-bao-2'
                        : item.labelCode
                    )}
                  </Link>
                ))}
            </div> */}
          <div className="tab-content-new tab-content-analysis">
            {tabActive === 'bieu-do-ky-thuat' && (
              <TabAnalysisChart symbol={_searchTxt} />
            )}
            {tabActive === 'phan-tich-thi-truong' && <TabAnalysisMarket />}
            {tabActive === 'phan-tich-co-phieu' && <TabAnalysisStock />}
            {tabActive === 'loc-co-phieu' && <TabAnalysisFilter />}
            {tabActive === 'canh-bao' && <TabAnalysisSignal />}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    socketReady: state.socket.socketReady,
    lang: state.client?.setting?.lang || 'vi',
  };
};

export default connect(mapStateToProps)(translate('translations')(CashPage));
